import type { TypedDocumentNode } from '@apollo/client';
import { gql } from '@apollo/client';

import { ManagerProgressionTaskState } from '@sorare/core/src/__generated__/globalTypes.ts';
import { WidgetChip } from '@sorare/core/src/atoms/ui/Chip/WidgetChip/index.tsx';
import { ANY_SPORT_SERIES_MISSIONS_PLAY } from '@sorare/core/src/constants/__generated__/routes.ts';
import { useSportContext } from '@sorare/core/src/contexts/sport';

import { DumbPlayMissionWidget } from '#src/components/missions/DumbPlayMissionWidget/index.tsx';

import type { PlayMissionWidget_taskInterface } from './__generated__/index.graphql.ts';

type Props = {
  task: PlayMissionWidget_taskInterface;
};

export const PlayMissionWidget = ({ task }: Props) => {
  const { generateSportContextPath } = useSportContext();

  const isCompleted = task.aasmState === ManagerProgressionTaskState.COMPLETED;
  const isClaimed = task.aasmState === ManagerProgressionTaskState.CLAIMED;

  return (
    <DumbPlayMissionWidget
      to={generateSportContextPath(ANY_SPORT_SERIES_MISSIONS_PLAY)}
      chip={
        (isCompleted && <WidgetChip state="reward" />) ||
        (isClaimed && <WidgetChip state="done" />) ||
        undefined
      }
    />
  );
};

PlayMissionWidget.fragments = {
  taskInterface: gql`
    fragment PlayMissionWidget_taskInterface on TaskInterface {
      id
      aasmState
    }
  ` as TypedDocumentNode<PlayMissionWidget_taskInterface>,
};
